import {
  mutateAsync as rqMutateAsync,
  requestAsync as rqRequestAsync,
} from 'redux-query';

import { selectServiceConfig } from '../../global-selectors';
import { selectBootstrapConfig, selectCouponApply } from '../selectors/bootstrap';
import { selectShoppingCartConfig } from '../selectors/shoppingCart';
import { selectUserData } from '../selectors/user';
import { QUERY_UPDATE_ENTITIES } from './constants';
import { selectProducts } from '../selectors/products';
import { applySalePrice } from '../../utils/products';
export const createAction = (type, payload) => ({ type, payload });
export const updateGlobalEntities = (payload) => createAction(QUERY_UPDATE_ENTITIES, payload);

/**
 * Handles updating subscriber entity with
 * user's selected membership
 *
 * @param {string} payload
 * @returns {function(*, *): Promise}
 */
export const deleteCouponCode = () => {
  return (dispatch, getState) => {
    const shoppingCart = selectShoppingCartConfig(getState());
    const coupon = selectCouponApply(getState());
    const updatedProducts = shoppingCart?.productsToBuy?.map(product => {
      if (coupon.products?.some(productId => productId === product.productID)) {
        delete product.discountPriceToShow;
      }
      return product;
    });
    return dispatch(updateGlobalEntities({
      shoppingCart: {
        ...shoppingCart,
        productsToBuy: updatedProducts
      },
      couponApply: {}
    }));
  };
};

/**
 * Handles updating subscriber entity with
 * user's selected membership
 *
 * @param {string} payload
 * @returns {function(*, *): Promise}
 */
export const applyCouponCode = (code) => {
  return (dispatch, getState) => {
    return dispatch(updateGlobalEntities({
      couponApply: {
        code
      }
    }));
  };
};

export const dismissCouponError = () => {
  return (dispatch) => {
    return dispatch(updateGlobalEntities({
      couponApply: { errorDismissed: true }
    }));
  };
};

/**
 * Wrapper for redux-query `requestAsync` which
 * handles unity serviceConfig and user data
 *
 * @param {QueryConfig} query
 * @param {any} [payload]
 * @returns {function(*, *): Promise}
 */
export const requestAsync = (query, payload) => (
  (dispatch, getState) => {
    const serviceConfig = selectServiceConfig(getState());
    const user = selectUserData(getState());

    return dispatch(
      rqRequestAsync(query({
        ...payload,
        serviceConfig,
        user,
      })),
    );
  }
);

/**
 * Wrapper for redux-query `mutateAsync` which
 * handles unity serviceConfig and user data
 *
 * @param {QueryConfig} query
 * @param {any} [payload]
 * @returns {function(*, *): Promise}
 */
export const mutateAsync = (query, payload) => (
  (dispatch, getState) => {
    const serviceConfig = selectServiceConfig(getState());
    const user = selectUserData(getState());

    return dispatch(
      rqMutateAsync(query({
        ...payload,
        serviceConfig,
        user,
      })),
    );
  }
);

export const hiddenCouponInput = (hidden) => {
  return (dispatch, getState) => {
    return dispatch(updateGlobalEntities({
      hiddenCouponInput: hidden
    }));
  };
};

/**
 * update exchange rate by device country on productList and bootstrap products config
 *
 * @returns {function(*, *): Promise}
 */
export const updateInitialExchangeByDeviceCountry = (payload) => {
  return (dispatch, getState) => {
    const { exchange, currency } = payload;
    const bootstrap = selectBootstrapConfig(getState());
    const products = applySalePrice(selectProducts(getState()));
    const productList = (products || [])
      .map((item) => {
        return {
          ...item,
          priceUsd: item.currency === 'USD' ? item.price : (item.price / exchange),
          realPriceUsd: item.currency === 'USD' ? item.realPrice : (item.realPrice / exchange),
          price: item.currency === 'USD' ? (item.price * (exchange || 1)) : item.price,
          priceToShow: item.currency === 'USD' ? (item.price * (exchange || 1)) : item.price,
          realPriceToShow: item.currency === 'USD' ? (item.realPrice * (exchange || 1)) : item.realPrice,
          exchangedPrice: exchange,
          originalCurrency: item.originalCurrency || item.currency,
          currency
        };
      });
    const list = (products || [])
      .reduce((acc, item) => {
        acc[item.productID] = {
          ...item,
          priceUsd: item.currency === 'USD' ? item.price : (item.price / exchange),
          realPriceUsd: item.currency === 'USD' ? item.realPrice : (item.realPrice / exchange),
          price: item.currency === 'USD' ? (item.price * exchange) : item.price,
          priceToShow: item.currency === 'USD' ? (item.price * exchange) : item.price,
          realPriceToShow: item.currency === 'USD' ? (item.realPrice * (exchange || 1)) : item.realPrice,
          originalCurrency: item.originalCurrency || item.currency,
          exchangedPrice: exchange,
          currency: currency
        };
        return acc;
      }, {});
    return dispatch(updateGlobalEntities({
      bootstrap: {
        ...bootstrap,
        products: productList
      },
      productList: list
    }));
  };
};

/**
 * Handle to reset of original user exchange
 *
 * @param {string} payload
 * @returns {function(*, *): Promise}
 */
export const resetProductExchange = () => {
  return (dispatch, getState) => {
    const user = selectUserData(getState());
    const products = selectProducts(getState());
    const productList = (products || [])
      .reduce((acc, item) => {
        acc[item.productID] = {
          ...item,
          priceUsd: item.currency === 'USD' ? item.price : (item.price / user.exchangeRate),
          priceToShow: item.price,
          originalCurrency: item.originalCurrency || item.currency,
          exchangedPrice: user.exchangeRate,
          currency: user.currency
        };
        return acc;
      }, {});
    return dispatch(updateGlobalEntities({
      productList
    }));
  };
};

export default null;
